import { render, staticRenderFns } from "./ArticlePreview.vue?vue&type=template&id=03a05f8d&"
import script from "./ArticlePreview.vue?vue&type=script&lang=js&"
export * from "./ArticlePreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports